// extracted by mini-css-extract-plugin
export default {"box":"n8YT2UoNWsbOXAXOQdbG","group":"hRYHoJ9pEN1syXCMn43O","inputColumn":"zyZfVmhLcre116TaZS7k"};